import { motion } from "framer-motion";

// Scroll-reveal wrapper used across sections
export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

// Section eyebrow label
export const Eyebrow = ({ children, className = "" }) => (
  <span className={`inline-block font-mono text-xs sm:text-sm font-bold tracking-[0.25em] uppercase text-mm-green ${className}`}>
    {children}
  </span>
);
